export const timezoneLabels = [
  {
    identifiers: ['Australia/Darwin', 'Australia/North'],
    label: 'Australian Central Standard Time',
  },
  {
    identifiers: [
      'Australia/Sydney',
      'Australia/ACT',
      'Australia/Canberra',
      'Australia/NSW',
    ],
    label: 'Eastern Australia Time - Sydney',
  },
  {
    identifiers: [
      'Africa/Nairobi',
      'Africa/Addis_Ababa',
      'Africa/Asmara',
      'Africa/Asmera',
      'Africa/Dar_es_Salaam',
      'Africa/Djibouti',
      'Africa/Kampala',
      'Africa/Mogadishu',
      'Indian/Antananarivo',
      'Indian/Comoro',
      'Indian/Mayotte',
    ],
    label: 'East Africa Time - Nairobi',
  },
  {
    identifiers: [
      'Africa/Abidjan',
      'Africa/Bamako',
      'Africa/Banjul',
      'Africa/Conakry',
      'Africa/Dakar',
      'Africa/Freetown',
      'Africa/Lome',
      'Africa/Nouakchott',
      'Africa/Ouagadougou',
      'Africa/Timbuktu',
      'Atlantic/St_Helena',
    ],
    label: 'Greenwich Mean Time - Abidjan',
  },
  {
    identifiers: [
      'Africa/Lagos',
      'Africa/Bangui',
      'Africa/Brazzaville',
      'Africa/Douala',
      'Africa/Kinshasa',
      'Africa/Libreville',
      'Africa/Luanda',
      'Africa/Malabo',
      'Africa/Niamey',
      'Africa/Porto-Novo',
    ],
    label: 'West Africa Standard Time - Lagos',
  },
  {
    identifiers: [
      'Africa/Maputo',
      'Africa/Blantyre',
      'Africa/Bujumbura',
      'Africa/Gaborone',
      'Africa/Harare',
      'Africa/Kigali',
      'Africa/Lubumbashi',
      'Africa/Lusaka',
    ],
    label: 'Central Africa Time - Maputo',
  },
  {
    identifiers: ['Africa/Johannesburg', 'Africa/Maseru', 'Africa/Mbabane'],
    label: 'South Africa Standard Time',
  },
  {
    identifiers: [
      'America/Port_of_Spain',
      'America/Anguilla',
      'America/Antigua',
      'America/Dominica',
      'America/Grenada',
      'America/Guadeloupe',
      'America/Marigot',
      'America/Montserrat',
      'America/St_Barthelemy',
      'America/St_Kitts',
      'America/St_Lucia',
      'America/St_Thomas',
      'America/St_Vincent',
      'America/Tortola',
      'America/Virgin',
    ],
    label: 'Atlantic Standard Time - Port of Spain',
  },
  {
    identifiers: [
      'America/Argentina/Catamarca',
      'America/Argentina/ComodRivadavia',
      'America/Catamarca',
    ],
    label: 'Argentina Standard Time - Catamarca',
  },
  {
    identifiers: [
      'America/Curacao',
      'America/Aruba',
      'America/Kralendijk',
      'America/Lower_Princes',
    ],
    label: 'Atlantic Standard Time - Curaçao',
  },
  {
    identifiers: ['America/Adak', 'America/Atka', 'US/Aleutian'],
    label: 'Hawaii-Aleutian Time (Adak)',
  },
  {
    identifiers: ['America/Argentina/Buenos_Aires', 'America/Buenos_Aires'],
    label: 'Argentina Standard Time - Buenos Aires',
  },
  {
    identifiers: ['America/Panama', 'America/Cayman'],
    label: 'Eastern Standard Time - Panama',
  },
  {
    identifiers: ['America/Atikokan', 'America/Coral_Harbour'],
    label: 'Eastern Standard Time - Atikokan',
  },
  {
    identifiers: [
      'America/Argentina/Cordoba',
      'America/Cordoba',
      'America/Rosario',
    ],
    label: 'Argentina Standard Time - Cordoba',
  },
  {
    identifiers: [
      'America/Tijuana',
      'America/Ensenada',
      'America/Santa_Isabel',
      'Mexico/BajaNorte',
    ],
    label: 'Pacific Time - Tijuana',
  },
  {
    identifiers: [
      'America/Indiana/Indianapolis',
      'America/Fort_Wayne',
      'America/Indianapolis',
      'US/East-Indiana',
    ],
    label: 'Eastern Time - Indianapolis',
  },
  {
    identifiers: ['America/Argentina/Jujuy', 'America/Jujuy'],
    label: 'Argentina Standard Time - Jujuy',
  },
  {
    identifiers: [
      'America/Indiana/Knox',
      'America/Knox_IN',
      'US/Indiana-Starke',
    ],
    label: 'Central Time - Knox, Indiana',
  },
  {
    identifiers: ['America/Kentucky/Louisville', 'America/Louisville'],
    label: 'Eastern Time - Louisville',
  },
  {
    identifiers: ['America/Argentina/Mendoza', 'America/Mendoza'],
    label: 'Argentina Standard Time - Mendoza',
  },
  {
    identifiers: ['America/Toronto', 'America/Montreal', 'Canada/Eastern'],
    label: 'Eastern Time - Toronto',
  },
  {
    identifiers: ['America/Rio_Branco', 'America/Porto_Acre', 'Brazil/Acre'],
    label: 'Acre Standard Time - Rio Branco',
  },
  {
    identifiers: [
      'America/Denver',
      'America/Shiprock',
      'Navajo',
      'US/Mountain',
    ],
    label: 'Mountain Time - Denver',
  },
  {
    identifiers: [
      'Pacific/Auckland',
      'Antarctica/McMurdo',
      'Antarctica/South_Pole',
      'NZ',
    ],
    label: 'New Zealand Time',
  },
  {
    identifiers: ['Europe/Oslo', 'Arctic/Longyearbyen', 'Atlantic/Jan_Mayen'],
    label: 'Central European Time - Oslo',
  },
  {
    identifiers: ['Africa/Cairo', 'Egypt'],
    label: 'Eastern European Standard Time - Cairo',
  },
  {
    identifiers: ['Asia/Riyadh', 'Asia/Aden', 'Asia/Kuwait'],
    label: 'Arabian Standard Time - Riyadh',
  },
  {
    identifiers: ['Asia/Ashgabat', 'Asia/Ashkhabad'],
    label: 'Turkmenistan Standard Time',
  },
  {
    identifiers: ['Asia/Qatar', 'Asia/Bahrain'],
    label: 'Arabian Standard Time - Qatar',
  },
  {
    identifiers: ['Asia/Kolkata', 'Asia/Calcutta'],
    label: 'India Standard Time - Kolkata',
  },
  {
    identifiers: [
      'Asia/Shanghai',
      'Asia/Chongqing',
      'Asia/Chungking',
      'Asia/Harbin',
      'PRC',
    ],
    label: 'China Standard Time - Shanghai',
  },
  {
    identifiers: ['Asia/Dhaka', 'Asia/Dacca'],
    label: 'Bangladesh Standard Time',
  },
  {
    identifiers: ['Europe/Istanbul', 'Asia/Istanbul', 'Turkey'],
    label: 'Turkey Time',
  },
  {
    identifiers: ['Asia/Urumqi', 'Asia/Kashgar'],
    label: 'Urumqi Time',
  },
  {
    identifiers: ['Asia/Kathmandu', 'Asia/Katmandu'],
    label: 'Nepal Time',
  },
  {
    identifiers: ['Asia/Macau', 'Asia/Macao'],
    label: 'China Standard Time - Macao',
  },
  {
    identifiers: ['Asia/Dubai', 'Asia/Muscat'],
    label: 'Gulf Standard Time',
  },
  {
    identifiers: ['Asia/Bangkok', 'Asia/Phnom_Penh', 'Asia/Vientiane'],
    label: 'Indochina Time - Bangkok',
  },
  {
    identifiers: ['Asia/Yangon', 'Asia/Rangoon'],
    label: 'Myanmar Time',
  },
  {
    identifiers: ['Asia/Ho_Chi_Minh', 'Asia/Saigon'],
    label: 'Indochina Time - Ho Chi Minh City',
  },
  {
    identifiers: ['Asia/Jerusalem', 'Asia/Tel_Aviv', 'Israel'],
    label: 'Israel Time',
  },
  {
    identifiers: ['Asia/Thimphu', 'Asia/Thimbu'],
    label: 'Bhutan Time',
  },
  {
    identifiers: ['Asia/Makassar', 'Asia/Ujung_Pandang'],
    label: 'Central Indonesia Time',
  },
  {
    identifiers: ['Asia/Ulaanbaatar', 'Asia/Ulan_Bator'],
    label: 'Ulaanbaatar Standard Time',
  },
  {
    identifiers: ['America/Anchorage', 'US/Alaska'],
    label: 'Alaska Time - Anchorage',
  },
  {
    identifiers: ['Atlantic/Faroe', 'Atlantic/Faeroe'],
    label: 'Western European Time - Faroe',
  },
  {
    identifiers: ['Australia/Lord_Howe', 'Australia/LHI'],
    label: 'Lord Howe Time',
  },
  {
    identifiers: ['Australia/Brisbane', 'Australia/Queensland'],
    label: 'Australian Eastern Standard Time - Brisbane',
  },
  {
    identifiers: ['Australia/Adelaide', 'Australia/South'],
    label: 'Central Australia Time - Adelaide',
  },
  {
    identifiers: ['Australia/Hobart', 'Australia/Tasmania'],
    label: 'Eastern Australia Time - Hobart',
  },
  {
    identifiers: ['Australia/Melbourne', 'Australia/Victoria'],
    label: 'Eastern Australia Time - Melbourne',
  },
  {
    identifiers: ['Australia/Perth', 'Australia/West'],
    label: 'Australian Western Standard Time - Perth',
  },
  {
    identifiers: ['Australia/Broken_Hill', 'Australia/Yancowinna'],
    label: 'Central Australia Time - Broken Hill',
  },
  {
    identifiers: ['America/Sao_Paulo', 'Brazil/East'],
    label: 'Brasilia Standard Time - Sao Paulo',
  },
  {
    identifiers: ['America/Noronha', 'Brazil/DeNoronha'],
    label: 'Fernando de Noronha Standard Time',
  },
  {
    identifiers: ['America/Manaus', 'Brazil/West'],
    label: 'Amazon Standard Time - Manaus',
  },
  {
    identifiers: ['America/Halifax', 'Canada/Atlantic'],
    label: 'Atlantic Time - Halifax',
  },
  {
    identifiers: ['America/Winnipeg', 'Canada/Central'],
    label: 'Central Time - Winnipeg',
  },
  {
    identifiers: ['America/Regina', 'Canada/Saskatchewan'],
    label: 'Central Standard Time - Regina',
  },
  {
    identifiers: ['America/Edmonton', 'Canada/Mountain'],
    label: 'Mountain Time - Edmonton',
  },
  {
    identifiers: ['America/Vancouver', 'Canada/Pacific'],
    label: 'Pacific Time - Vancouver',
  },
  {
    identifiers: ['America/Whitehorse', 'Canada/Yukon'],
    label: 'Pacific Time - Whitehorse',
  },
  {
    identifiers: ['America/Santiago', 'Chile/Continental'],
    label: 'Chile Time',
  },
  {
    identifiers: ['Pacific/Easter', 'Chile/EasterIsland'],
    label: 'Easter Island Time',
  },
  {
    identifiers: ['America/St_Johns', 'Canada/Newfoundland'],
    label: 'Newfoundland Time',
  },
  {
    identifiers: ['America/Chicago', 'US/Central'],
    label: 'Central Time - Chicago',
  },
  {
    identifiers: ['America/Havana', 'Cuba'],
    label: 'Cuba Time',
  },
  {
    identifiers: ['Europe/Paris'],
    label: 'Central European Time - Paris',
  },
  {
    identifiers: ['Europe/Dublin', 'Eire'],
    label: 'Ireland Time',
  },
  {
    identifiers: [
      'Etc/GMT',
      'Etc/GMT+0',
      'Etc/GMT-0',
      'Etc/GMT0',
      'Etc/Greenwich',
      'GMT',
      'GMT+0',
      'GMT-0',
      'GMT0',
      'Greenwich',
    ],
    label: 'Greenwich Mean Time',
  },
  {
    identifiers: [
      'Europe/London',
      'Europe/Belfast',
      'Europe/Guernsey',
      'Europe/Isle_of_Man',
      'Europe/Jersey',
      'GB',
      'GB-Eire',
    ],
    label: 'United Kingdom Time',
  },
  {
    identifiers: ['Europe/Prague', 'Europe/Bratislava'],
    label: 'Central European Time - Prague',
  },
  {
    identifiers: ['Europe/Zurich', 'Europe/Busingen', 'Europe/Vaduz'],
    label: 'Central European Time - Zurich',
  },
  {
    identifiers: [
      'Europe/Belgrade',
      'Europe/Ljubljana',
      'Europe/Podgorica',
      'Europe/Sarajevo',
      'Europe/Skopje',
      'Europe/Zagreb',
    ],
    label: 'Central European Time - Belgrade',
  },
  {
    identifiers: ['Europe/Helsinki', 'Europe/Mariehamn'],
    label: 'Eastern European Time - Helsinki',
  },
  {
    identifiers: ['Asia/Nicosia', 'Europe/Nicosia'],
    label: 'Eastern European Time - Nicosia',
  },
  {
    identifiers: ['Europe/Rome', 'Europe/San_Marino', 'Europe/Vatican'],
    label: 'Central European Time - Rome',
  },
  {
    identifiers: ['Europe/Chisinau', 'Europe/Tiraspol'],
    label: 'Eastern European Time - Chisinau',
  },
  {
    identifiers: ['Asia/Hong_Kong', 'Hongkong'],
    label: 'Hong Kong Standard Time',
  },
  {
    identifiers: ['Atlantic/Reykjavik', 'Iceland'],
    label: 'Greenwich Mean Time - Reykjavik',
  },
  {
    identifiers: ['Asia/Tehran', 'Iran'],
    label: 'Iran Time',
  },
  {
    identifiers: ['America/Jamaica', 'Jamaica'],
    label: 'Eastern Standard Time - Jamaica',
  },
  {
    identifiers: ['Asia/Tokyo', 'Japan'],
    label: 'Japan Standard Time',
  },
  {
    identifiers: ['Pacific/Kwajalein', 'Kwajalein'],
    label: 'Marshall Islands Time - Kwajalein',
  },
  {
    identifiers: ['Africa/Tripoli', 'Libya'],
    label: 'Eastern European Standard Time - Tripoli',
  },
  {
    identifiers: ['America/Mazatlan', 'Mexico/BajaSur'],
    label: 'Mexican Pacific Time - Mazatlan',
  },
  {
    identifiers: ['America/Mexico_City', 'Mexico/General'],
    label: 'Central Time - Mexico City',
  },
  {
    identifiers: ['Pacific/Apia'],
    label: 'Apia Time',
  },
  {
    identifiers: ['Asia/Yerevan'],
    label: 'Armenia Standard Time',
  },
  {
    identifiers: ['Pacific/Chatham', 'NZ-CHAT'],
    label: 'Chatham Time',
  },
  {
    identifiers: ['Pacific/Honolulu', 'Pacific/Johnston', 'US/Hawaii'],
    label: 'Hawaii-Aleutian Standard Time',
  },
  {
    identifiers: [
      'Pacific/Pago_Pago',
      'Pacific/Pago_Pago',
      'Pacific/Samoa',
      'Pacific/Midway',
    ],
    label: 'Samoa Standard Time',
  },
  {
    identifiers: ['Pacific/Pohnpei', 'Pacific/Pohnpei', 'Pacific/Ponape'],
    label: 'Ponape Time',
  },
  {
    identifiers: ['Pacific/Guam', 'Pacific/Guam', 'Pacific/Saipan'],
    label: 'Chamorro Standard Time',
  },
  {
    identifiers: [
      'Pacific/Chuuk',
      'Pacific/Chuuk',
      'Pacific/Yap',
      'Pacific/Truk',
    ],
    label: 'Chuuk Time',
  },
  {
    identifiers: ['Asia/Karachi', 'Asia/Karachi'],
    label: 'Pakistan Standard Time',
  },
  {
    identifiers: ['America/Phoenix', 'America/Phoenix', 'US/Arizona'],
    label: 'Mountain Standard Time - Phoenix',
  },
  {
    identifiers: ['Europe/Warsaw', 'Europe/Warsaw', 'Poland'],
    label: 'Central European Time - Warsaw',
  },
  {
    identifiers: ['Europe/Lisbon', 'Europe/Lisbon', 'Portugal'],
    label: 'Western European Time - Lisbon',
  },
  {
    identifiers: ['America/Puerto_Rico', 'America/Puerto_Rico'],
    label: 'Atlantic Standard Time - Puerto Rico',
  },
  {
    identifiers: ['America/Los_Angeles', 'America/Los_Angeles', 'US/Pacific'],
    label: 'Pacific Time - Los Angeles',
  },
  {
    identifiers: ['Asia/Taipei', 'Asia/Taipei', 'ROC'],
    label: 'Taipei Standard Time',
  },
  {
    identifiers: ['Asia/Seoul', 'Asia/Seoul', 'ROK'],
    label: 'Korean Standard Time - Seoul',
  },
  {
    identifiers: ['Asia/Singapore', 'Asia/Singapore', 'Singapore'],
    label: 'Singapore Standard Time',
  },
  {
    identifiers: ['Pacific/Guadalcanal', 'Pacific/Guadalcanal'],
    label: 'Solomon Islands Time',
  },
  {
    identifiers: ['America/New_York', 'America/New_York', 'US/Eastern'],
    label: 'Eastern Time - New York',
  },
  {
    identifiers: ['America/Detroit', 'America/Detroit', 'US/Michigan'],
    label: 'Eastern Time - Detroit',
  },
  {
    identifiers: ['Europe/Moscow', 'Europe/Moscow'],
    label: 'Moscow Standard Time - Moscow',
  },
  {
    identifiers: ['Africa/Accra', 'Africa/Accra'],
    label: 'Greenwich Mean Time - Accra',
  },
  {
    identifiers: ['Africa/Algiers', 'Africa/Algiers'],
    label: 'Central European Standard Time - Algiers',
  },
  {
    identifiers: ['Africa/Bissau', 'Africa/Bissau'],
    label: 'Greenwich Mean Time - Bissau',
  },
  {
    identifiers: ['Africa/Casablanca', 'Africa/Casablanca'],
    label: 'Morocco Time',
  },
  {
    identifiers: ['Africa/Ceuta', 'Africa/Ceuta'],
    label: 'Central European Time - Ceuta',
  },
  {
    identifiers: ['Africa/El_Aaiun', 'Africa/El_Aaiun'],
    label: 'Western Sahara Time',
  },
  {
    identifiers: ['Africa/Juba', 'Africa/Juba'],
    label: 'East Africa Time - Juba',
  },
  {
    identifiers: ['Africa/Khartoum', 'Africa/Khartoum'],
    label: 'Central Africa Time - Khartoum',
  },
  {
    identifiers: ['Africa/Monrovia', 'Africa/Monrovia'],
    label: 'Greenwich Mean Time - Monrovia',
  },
  {
    identifiers: ['Africa/Ndjamena', 'Africa/Ndjamena'],
    label: 'West Africa Standard Time - Ndjamena',
  },
  {
    identifiers: ['Africa/Sao_Tome', 'Africa/Sao_Tome'],
    label: 'Greenwich Mean Time - São Tomé',
  },
  {
    identifiers: ['Africa/Tunis', 'Africa/Tunis'],
    label: 'Central European Standard Time - Tunis',
  },
  {
    identifiers: ['Africa/Windhoek', 'Africa/Windhoek'],
    label: 'Central Africa Time - Windhoek',
  },
  {
    identifiers: ['America/Araguaina', 'America/Araguaina'],
    label: 'Brasilia Standard Time - Araguaina',
  },
  {
    identifiers: ['America/Argentina/La_Rioja', 'America/Argentina/La_Rioja'],
    label: 'Argentina Standard Time - La Rioja',
  },
  {
    identifiers: [
      'America/Argentina/Rio_Gallegos',
      'America/Argentina/Rio_Gallegos',
    ],
    label: 'Argentina Standard Time - Rio Gallegos',
  },
  {
    identifiers: ['America/Argentina/Salta', 'America/Argentina/Salta'],
    label: 'Argentina Standard Time - Salta',
  },
  {
    identifiers: ['America/Argentina/San_Juan', 'America/Argentina/San_Juan'],
    label: 'Argentina Standard Time - San Juan',
  },
  {
    identifiers: ['America/Argentina/San_Luis', 'America/Argentina/San_Luis'],
    label: 'Western Argentina Standard Time',
  },
  {
    identifiers: ['America/Argentina/Tucuman', 'America/Argentina/Tucuman'],
    label: 'Argentina Standard Time - Tucuman',
  },
  {
    identifiers: ['America/Argentina/Ushuaia', 'America/Argentina/Ushuaia'],
    label: 'Argentina Standard Time - Ushuaia',
  },
  {
    identifiers: ['America/Asuncion', 'America/Asuncion'],
    label: 'Paraguay Time',
  },
  {
    identifiers: ['America/Bahia_Banderas', 'America/Bahia_Banderas'],
    label: 'Central Time - Bahia Banderas',
  },
  {
    identifiers: ['America/Bahia', 'America/Bahia'],
    label: 'Brasilia Standard Time - Bahia',
  },
  {
    identifiers: ['America/Barbados', 'America/Barbados'],
    label: 'Atlantic Standard Time - Barbados',
  },
  {
    identifiers: ['America/Belem', 'America/Belem'],
    label: 'Brasilia Standard Time - Belem',
  },
  {
    identifiers: ['America/Belize', 'America/Belize'],
    label: 'Central Standard Time - Belize',
  },
  {
    identifiers: ['America/Blanc-Sablon', 'America/Blanc-Sablon'],
    label: 'Atlantic Standard Time - Blanc-Sablon',
  },
  {
    identifiers: ['America/Boa_Vista', 'America/Boa_Vista'],
    label: 'Amazon Standard Time - Boa Vista',
  },
  {
    identifiers: ['America/Bogota', 'America/Bogota'],
    label: 'Colombia Standard Time',
  },
  {
    identifiers: ['America/Boise', 'America/Boise'],
    label: 'Mountain Time - Boise',
  },
  {
    identifiers: ['America/Cambridge_Bay', 'America/Cambridge_Bay'],
    label: 'Mountain Time - Cambridge Bay',
  },
  {
    identifiers: ['America/Campo_Grande', 'America/Campo_Grande'],
    label: 'Amazon Standard Time - Campo Grande',
  },
  {
    identifiers: ['America/Cancun', 'America/Cancun'],
    label: 'Eastern Standard Time - Cancun',
  },
  {
    identifiers: ['America/Caracas', 'America/Caracas'],
    label: 'Venezuela Time',
  },
  {
    identifiers: ['America/Cayenne', 'America/Cayenne'],
    label: 'French Guiana Time',
  },
  {
    identifiers: ['America/Chihuahua', 'America/Chihuahua'],
    label: 'Mexican Pacific Time - Chihuahua',
  },
  {
    identifiers: ['America/Costa_Rica', 'America/Costa_Rica'],
    label: 'Central Standard Time - Costa Rica',
  },
  {
    identifiers: ['America/Creston', 'America/Creston'],
    label: 'Mountain Standard Time - Creston',
  },
  {
    identifiers: ['America/Cuiaba', 'America/Cuiaba'],
    label: 'Amazon Standard Time - Cuiaba',
  },
  {
    identifiers: ['America/Danmarkshavn', 'America/Danmarkshavn'],
    label: 'Greenwich Mean Time - Danmarkshavn',
  },
  {
    identifiers: ['America/Dawson_Creek', 'America/Dawson_Creek'],
    label: 'Mountain Standard Time - Dawson Creek',
  },
  {
    identifiers: ['America/Dawson', 'America/Dawson'],
    label: 'Pacific Time - Dawson',
  },
  {
    identifiers: ['America/Eirunepe', 'America/Eirunepe'],
    label: 'Acre Standard Time - Eirunepe',
  },
  {
    identifiers: ['America/El_Salvador', 'America/El_Salvador'],
    label: 'Central Standard Time - El Salvador',
  },
  {
    identifiers: ['America/Fort_Nelson', 'America/Fort_Nelson'],
    label: 'Mountain Standard Time - Fort Nelson',
  },
  {
    identifiers: ['America/Fortaleza', 'America/Fortaleza'],
    label: 'Brasilia Standard Time - Fortaleza',
  },
  {
    identifiers: ['America/Glace_Bay', 'America/Glace_Bay'],
    label: 'Atlantic Time - Glace Bay',
  },
  {
    identifiers: ['America/Godthab', 'America/Godthab'],
    label: 'West Greenland Time',
  },
  {
    identifiers: ['America/Goose_Bay', 'America/Goose_Bay'],
    label: 'Atlantic Time - Goose Bay',
  },
  {
    identifiers: ['America/Grand_Turk', 'America/Grand_Turk'],
    label: 'Eastern Time - Grand Turk',
  },
  {
    identifiers: ['America/Guatemala', 'America/Guatemala'],
    label: 'Central Standard Time - Guatemala',
  },
  {
    identifiers: ['America/Guayaquil', 'America/Guayaquil'],
    label: 'Ecuador Time',
  },
  {
    identifiers: ['America/Guyana', 'America/Guyana'],
    label: 'Guyana Time',
  },
  {
    identifiers: ['America/Hermosillo', 'America/Hermosillo'],
    label: 'Mexican Pacific Standard Time',
  },
  {
    identifiers: ['America/Indiana/Marengo', 'America/Indiana/Marengo'],
    label: 'Eastern Time - Marengo, Indiana',
  },
  {
    identifiers: ['America/Indiana/Petersburg', 'America/Indiana/Petersburg'],
    label: 'Eastern Time - Petersburg, Indiana',
  },
  {
    identifiers: ['America/Indiana/Tell_City', 'America/Indiana/Tell_City'],
    label: 'Central Time - Tell City, Indiana',
  },
  {
    identifiers: ['America/Indiana/Vevay', 'America/Indiana/Vevay'],
    label: 'Eastern Time - Vevay, Indiana',
  },
  {
    identifiers: ['America/Indiana/Vincennes', 'America/Indiana/Vincennes'],
    label: 'Eastern Time - Vincennes, Indiana',
  },
  {
    identifiers: ['America/Indiana/Winamac', 'America/Indiana/Winamac'],
    label: 'Eastern Time - Winamac, Indiana',
  },
  {
    identifiers: ['America/Inuvik', 'America/Inuvik'],
    label: 'Mountain Time - Inuvik',
  },
  {
    identifiers: ['America/Iqaluit', 'America/Iqaluit'],
    label: 'Eastern Time - Iqaluit',
  },
  {
    identifiers: ['America/Juneau', 'America/Juneau'],
    label: 'Alaska Time - Juneau',
  },
  {
    identifiers: ['America/Kentucky/Monticello', 'America/Kentucky/Monticello'],
    label: 'Eastern Time - Monticello, Kentucky',
  },
  {
    identifiers: ['America/La_Paz', 'America/La_Paz'],
    label: 'Bolivia Time',
  },
  {
    identifiers: ['America/Lima', 'America/Lima'],
    label: 'Peru Standard Time',
  },
  {
    identifiers: ['America/Maceio', 'America/Maceio'],
    label: 'Brasilia Standard Time - Maceio',
  },
  {
    identifiers: ['America/Managua', 'America/Managua'],
    label: 'Central Standard Time - Managua',
  },
  {
    identifiers: ['America/Martinique', 'America/Martinique'],
    label: 'Atlantic Standard Time - Martinique',
  },
  {
    identifiers: ['America/Matamoros', 'America/Matamoros'],
    label: 'Central Time - Matamoros',
  },
  {
    identifiers: ['America/Menominee', 'America/Menominee'],
    label: 'Central Time - Menominee',
  },
  {
    identifiers: ['America/Merida', 'America/Merida'],
    label: 'Central Time - Merida',
  },
  {
    identifiers: ['America/Metlakatla', 'America/Metlakatla'],
    label: 'Alaska Time - Metlakatla',
  },
  {
    identifiers: ['America/Miquelon', 'America/Miquelon'],
    label: 'St. Pierre & Miquelon Time',
  },
  {
    identifiers: ['America/Moncton', 'America/Moncton'],
    label: 'Atlantic Time - Moncton',
  },
  {
    identifiers: ['America/Monterrey', 'America/Monterrey'],
    label: 'Central Time - Monterrey',
  },
  {
    identifiers: ['America/Montevideo', 'America/Montevideo'],
    label: 'Uruguay Standard Time',
  },
  {
    identifiers: ['America/Nassau', 'America/Nassau'],
    label: 'Eastern Time - Nassau',
  },
  {
    identifiers: ['America/Nipigon', 'America/Nipigon'],
    label: 'Eastern Time - Nipigon',
  },
  {
    identifiers: ['America/Nome', 'America/Nome'],
    label: 'Alaska Time - Nome',
  },
  {
    identifiers: ['America/North_Dakota/Beulah', 'America/North_Dakota/Beulah'],
    label: 'Central Time - Beulah, North Dakota',
  },
  {
    identifiers: ['America/North_Dakota/Center', 'America/North_Dakota/Center'],
    label: 'Central Time - Center, North Dakota',
  },
  {
    identifiers: [
      'America/North_Dakota/New_Salem',
      'America/North_Dakota/New_Salem',
    ],
    label: 'Central Time - New Salem, North Dakota',
  },
  {
    identifiers: ['America/Ojinaga', 'America/Ojinaga'],
    label: 'Mountain Time - Ojinaga',
  },
  {
    identifiers: ['America/Pangnirtung', 'America/Pangnirtung'],
    label: 'Eastern Time - Pangnirtung',
  },
  {
    identifiers: ['America/Paramaribo', 'America/Paramaribo'],
    label: 'Suriname Time',
  },
  {
    identifiers: ['America/Port-au-Prince', 'America/Port-au-Prince'],
    label: 'Eastern Time - Port-au-Prince',
  },
  {
    identifiers: ['America/Porto_Velho', 'America/Porto_Velho'],
    label: 'Amazon Standard Time - Porto Velho',
  },
  {
    identifiers: ['America/Punta_Arenas', 'America/Punta_Arenas'],
    label: 'Punta Arenas Time',
  },
  {
    identifiers: ['America/Rainy_River', 'America/Rainy_River'],
    label: 'Central Time - Rainy River',
  },
  {
    identifiers: ['America/Rankin_Inlet', 'America/Rankin_Inlet'],
    label: 'Central Time - Rankin Inlet',
  },
  {
    identifiers: ['America/Recife', 'America/Recife'],
    label: 'Brasilia Standard Time - Recife',
  },
  {
    identifiers: ['America/Resolute', 'America/Resolute'],
    label: 'Central Time - Resolute',
  },
  {
    identifiers: ['America/Santarem', 'America/Santarem'],
    label: 'Brasilia Standard Time - Santarem',
  },
  {
    identifiers: ['America/Santo_Domingo', 'America/Santo_Domingo'],
    label: 'Atlantic Standard Time - Santo Domingo',
  },
  {
    identifiers: ['America/Scoresbysund', 'America/Scoresbysund'],
    label: 'East Greenland Time',
  },
  {
    identifiers: ['America/Sitka', 'America/Sitka'],
    label: 'Alaska Time - Sitka',
  },
  {
    identifiers: ['America/Swift_Current', 'America/Swift_Current'],
    label: 'Central Standard Time - Swift Current',
  },
  {
    identifiers: ['America/Tegucigalpa', 'America/Tegucigalpa'],
    label: 'Central Standard Time - Tegucigalpa',
  },
  {
    identifiers: ['America/Thule', 'America/Thule'],
    label: 'Atlantic Time - Thule',
  },
  {
    identifiers: ['America/Thunder_Bay', 'America/Thunder_Bay'],
    label: 'Eastern Time - Thunder Bay',
  },
  {
    identifiers: ['America/Yakutat', 'America/Yakutat'],
    label: 'Alaska Time - Yakutat',
  },
  {
    identifiers: ['America/Yellowknife', 'America/Yellowknife'],
    label: 'Mountain Time - Yellowknife',
  },
  {
    identifiers: ['Antarctica/Casey', 'Antarctica/Casey'],
    label: 'Australian Western Standard Time - Casey',
  },
  {
    identifiers: ['Antarctica/Davis', 'Antarctica/Davis'],
    label: 'Davis Time',
  },
  {
    identifiers: ['Antarctica/DumontDUrville', 'Antarctica/DumontDUrville'],
    label: 'Dumont-d’Urville Time',
  },
  {
    identifiers: ['Antarctica/Macquarie', 'Antarctica/Macquarie'],
    label: 'Macquarie Island Time',
  },
  {
    identifiers: ['Antarctica/Mawson', 'Antarctica/Mawson'],
    label: 'Mawson Time',
  },
  {
    identifiers: ['Antarctica/Palmer', 'Antarctica/Palmer'],
    label: 'Palmer Time',
  },
  {
    identifiers: ['Antarctica/Rothera', 'Antarctica/Rothera'],
    label: 'Rothera Time',
  },
  {
    identifiers: ['Antarctica/Syowa', 'Antarctica/Syowa'],
    label: 'Syowa Time',
  },
  {
    identifiers: ['Antarctica/Troll', 'Antarctica/Troll'],
    label: 'Troll Time',
  },
  {
    identifiers: ['Antarctica/Vostok', 'Antarctica/Vostok'],
    label: 'Vostok Time',
  },
  {
    identifiers: ['Asia/Almaty', 'Asia/Almaty'],
    label: 'East Kazakhstan Time - Almaty',
  },
  {
    identifiers: ['Asia/Amman', 'Asia/Amman'],
    label: 'Eastern European Time - Amman',
  },
  {
    identifiers: ['Asia/Anadyr', 'Asia/Anadyr'],
    label: 'Anadyr Standard Time',
  },
  {
    identifiers: ['Asia/Aqtau', 'Asia/Aqtau'],
    label: 'West Kazakhstan Time - Aqtau',
  },
  {
    identifiers: ['Asia/Aqtobe', 'Asia/Aqtobe'],
    label: 'West Kazakhstan Time - Aqtobe',
  },
  {
    identifiers: ['Asia/Atyrau', 'Asia/Atyrau'],
    label: 'West Kazakhstan Time - Atyrau',
  },
  {
    identifiers: ['Asia/Baghdad', 'Asia/Baghdad'],
    label: 'Arabian Standard Time - Baghdad',
  },
  {
    identifiers: ['Asia/Baku', 'Asia/Baku'],
    label: 'Azerbaijan Standard Time',
  },
  {
    identifiers: ['Asia/Barnaul', 'Asia/Barnaul'],
    label: 'Barnaul Time',
  },
  {
    identifiers: ['Asia/Beirut', 'Asia/Beirut'],
    label: 'Eastern European Time - Beirut',
  },
  {
    identifiers: ['Asia/Bishkek', 'Asia/Bishkek'],
    label: 'Kyrgyzstan Time',
  },
  {
    identifiers: ['Asia/Brunei', 'Asia/Brunei'],
    label: 'Brunei Darussalam Time',
  },
  {
    identifiers: ['Asia/Chita', 'Asia/Chita'],
    label: 'Yakutsk Standard Time - Chita',
  },
  {
    identifiers: ['Asia/Choibalsan', 'Asia/Choibalsan'],
    label: 'Choibalsan Standard Time',
  },
  {
    identifiers: ['Asia/Colombo', 'Asia/Colombo'],
    label: 'India Standard Time - Colombo',
  },
  {
    identifiers: ['Asia/Damascus', 'Asia/Damascus'],
    label: 'Eastern European Time - Damascus',
  },
  {
    identifiers: ['Asia/Dili', 'Asia/Dili'],
    label: 'East Timor Time',
  },
  {
    identifiers: ['Asia/Dushanbe', 'Asia/Dushanbe'],
    label: 'Tajikistan Time',
  },
  {
    identifiers: ['Asia/Famagusta', 'Asia/Famagusta'],
    label: 'Famagusta Time',
  },
  {
    identifiers: ['Asia/Gaza', 'Asia/Gaza'],
    label: 'Eastern European Time - Gaza',
  },
  {
    identifiers: ['Asia/Hebron', 'Asia/Hebron'],
    label: 'Eastern European Time - Hebron',
  },
  {
    identifiers: ['Asia/Hovd', 'Asia/Hovd'],
    label: 'Hovd Standard Time',
  },
  {
    identifiers: ['Asia/Irkutsk', 'Asia/Irkutsk'],
    label: 'Irkutsk Standard Time',
  },
  {
    identifiers: ['Asia/Jakarta', 'Asia/Jakarta'],
    label: 'Western Indonesia Time - Jakarta',
  },
  {
    identifiers: ['Asia/Jayapura', 'Asia/Jayapura'],
    label: 'Eastern Indonesia Time',
  },
  {
    identifiers: ['Asia/Kabul', 'Asia/Kabul'],
    label: 'Afghanistan Time',
  },
  {
    identifiers: ['Asia/Kamchatka', 'Asia/Kamchatka'],
    label: 'Petropavlovsk-Kamchatski Standard Time',
  },
  {
    identifiers: ['Asia/Khandyga', 'Asia/Khandyga'],
    label: 'Yakutsk Standard Time - Khandyga',
  },
  {
    identifiers: ['Asia/Krasnoyarsk', 'Asia/Krasnoyarsk'],
    label: 'Krasnoyarsk Standard Time - Krasnoyarsk',
  },
  {
    identifiers: ['Asia/Kuala_Lumpur', 'Asia/Kuala_Lumpur'],
    label: 'Malaysia Time - Kuala Lumpur',
  },
  {
    identifiers: ['Asia/Kuching', 'Asia/Kuching'],
    label: 'Malaysia Time - Kuching',
  },
  {
    identifiers: ['Asia/Magadan', 'Asia/Magadan'],
    label: 'Magadan Standard Time',
  },
  {
    identifiers: ['Asia/Manila', 'Asia/Manila'],
    label: 'Philippine Standard Time',
  },
  {
    identifiers: ['Asia/Novokuznetsk', 'Asia/Novokuznetsk'],
    label: 'Krasnoyarsk Standard Time - Novokuznetsk',
  },
  {
    identifiers: ['Asia/Novosibirsk', 'Asia/Novosibirsk'],
    label: 'Novosibirsk Standard Time',
  },
  {
    identifiers: ['Asia/Omsk', 'Asia/Omsk'],
    label: 'Omsk Standard Time',
  },
  {
    identifiers: ['Asia/Oral', 'Asia/Oral'],
    label: 'West Kazakhstan Time - Oral',
  },
  {
    identifiers: ['Asia/Pontianak', 'Asia/Pontianak'],
    label: 'Western Indonesia Time - Pontianak',
  },
  {
    identifiers: ['Asia/Pyongyang', 'Asia/Pyongyang'],
    label: 'Korean Standard Time - Pyongyang',
  },
  {
    identifiers: ['Asia/Qostanay', 'Asia/Qostanay'],
    label: 'East Kazakhstan Time - Kostanay',
  },
  {
    identifiers: ['Asia/Qyzylorda', 'Asia/Qyzylorda'],
    label: 'West Kazakhstan Time - Qyzylorda',
  },
  {
    identifiers: ['Asia/Sakhalin', 'Asia/Sakhalin'],
    label: 'Sakhalin Standard Time',
  },
  {
    identifiers: ['Asia/Samarkand', 'Asia/Samarkand'],
    label: 'Uzbekistan Standard Time - Samarkand',
  },
  {
    identifiers: ['Asia/Srednekolymsk', 'Asia/Srednekolymsk'],
    label: 'Srednekolymsk Time',
  },
  {
    identifiers: ['Asia/Tashkent', 'Asia/Tashkent'],
    label: 'Uzbekistan Standard Time - Tashkent',
  },
  {
    identifiers: ['Asia/Tbilisi', 'Asia/Tbilisi'],
    label: 'Georgia Standard Time',
  },
  {
    identifiers: ['Asia/Tomsk', 'Asia/Tomsk'],
    label: 'Tomsk Time',
  },
  {
    identifiers: ['Asia/Ust-Nera', 'Asia/Ust-Nera'],
    label: 'Vladivostok Standard Time - Ust-Nera',
  },
  {
    identifiers: ['Asia/Vladivostok', 'Asia/Vladivostok'],
    label: 'Vladivostok Standard Time - Vladivostok',
  },
  {
    identifiers: ['Asia/Yakutsk', 'Asia/Yakutsk'],
    label: 'Yakutsk Standard Time - Yakutsk',
  },
  {
    identifiers: ['Asia/Yekaterinburg', 'Asia/Yekaterinburg'],
    label: 'Yekaterinburg Standard Time',
  },
  {
    identifiers: ['Atlantic/Azores', 'Atlantic/Azores'],
    label: 'Azores Time',
  },
  {
    identifiers: ['Atlantic/Bermuda', 'Atlantic/Bermuda'],
    label: 'Atlantic Time - Bermuda',
  },
  {
    identifiers: ['Atlantic/Canary', 'Atlantic/Canary'],
    label: 'Western European Time - Canary',
  },
  {
    identifiers: ['Atlantic/Cape_Verde', 'Atlantic/Cape_Verde'],
    label: 'Cape Verde Standard Time',
  },
  {
    identifiers: ['Atlantic/Madeira', 'Atlantic/Madeira'],
    label: 'Western European Time - Madeira',
  },
  {
    identifiers: ['Atlantic/South_Georgia', 'Atlantic/South_Georgia'],
    label: 'South Georgia Time',
  },
  {
    identifiers: ['Atlantic/Stanley', 'Atlantic/Stanley'],
    label: 'Falkland Islands Standard Time',
  },
  {
    identifiers: ['Australia/Currie', 'Australia/Currie'],
    label: 'Eastern Australia Time - Currie',
  },
  {
    identifiers: ['Australia/Eucla', 'Australia/Eucla'],
    label: 'Australian Central Western Standard Time',
  },
  {
    identifiers: ['Australia/Lindeman', 'Australia/Lindeman'],
    label: 'Australian Eastern Standard Time - Lindeman',
  },
  {
    identifiers: ['Europe/Amsterdam', 'Europe/Amsterdam'],
    label: 'Central European Time - Amsterdam',
  },
  {
    identifiers: ['Europe/Andorra', 'Europe/Andorra'],
    label: 'Central European Time - Andorra',
  },
  {
    identifiers: ['Europe/Astrakhan', 'Europe/Astrakhan'],
    label: 'Astrakhan Time',
  },
  {
    identifiers: ['Europe/Athens', 'Europe/Athens'],
    label: 'Eastern European Time - Athens',
  },
  {
    identifiers: ['Europe/Berlin', 'Europe/Berlin'],
    label: 'Central European Time - Berlin',
  },
  {
    identifiers: ['Europe/Brussels', 'Europe/Brussels'],
    label: 'Central European Time - Brussels',
  },
  {
    identifiers: ['Europe/Bucharest', 'Europe/Bucharest'],
    label: 'Eastern European Time - Bucharest',
  },
  {
    identifiers: ['Europe/Budapest', 'Europe/Budapest'],
    label: 'Central European Time - Budapest',
  },
  {
    identifiers: ['Europe/Copenhagen', 'Europe/Copenhagen'],
    label: 'Central European Time - Copenhagen',
  },
  {
    identifiers: ['Europe/Gibraltar', 'Europe/Gibraltar'],
    label: 'Central European Time - Gibraltar',
  },
  {
    identifiers: ['Europe/Kaliningrad', 'Europe/Kaliningrad'],
    label: 'Eastern European Standard Time - Kaliningrad',
  },
  {
    identifiers: ['Europe/Kiev', 'Europe/Kiev'],
    label: 'Eastern European Time - Kiev',
  },
  {
    identifiers: ['Europe/Kirov', 'Europe/Kirov'],
    label: 'Kirov Time',
  },
  {
    identifiers: ['Europe/Luxembourg', 'Europe/Luxembourg'],
    label: 'Central European Time - Luxembourg',
  },
  {
    identifiers: ['Europe/Madrid', 'Europe/Madrid'],
    label: 'Central European Time - Madrid',
  },
  {
    identifiers: ['Europe/Malta', 'Europe/Malta'],
    label: 'Central European Time - Malta',
  },
  {
    identifiers: ['Europe/Minsk', 'Europe/Minsk'],
    label: 'Moscow Standard Time - Minsk',
  },
  {
    identifiers: ['Europe/Monaco', 'Europe/Monaco'],
    label: 'Central European Time - Monaco',
  },
  {
    identifiers: ['Europe/Riga', 'Europe/Riga'],
    label: 'Eastern European Time - Riga',
  },
  {
    identifiers: ['Europe/Samara', 'Europe/Samara'],
    label: 'Samara Standard Time',
  },
  {
    identifiers: ['Europe/Saratov', 'Europe/Saratov'],
    label: 'Saratov Time',
  },
  {
    identifiers: ['Europe/Simferopol', 'Europe/Simferopol'],
    label: 'Moscow Standard Time - Simferopol',
  },
  {
    identifiers: ['Europe/Sofia', 'Europe/Sofia'],
    label: 'Eastern European Time - Sofia',
  },
  {
    identifiers: ['Europe/Stockholm', 'Europe/Stockholm'],
    label: 'Central European Time - Stockholm',
  },
  {
    identifiers: ['Europe/Tallinn', 'Europe/Tallinn'],
    label: 'Eastern European Time - Tallinn',
  },
  {
    identifiers: ['Europe/Tirane', 'Europe/Tirane'],
    label: 'Central European Time - Tirane',
  },
  {
    identifiers: ['Europe/Ulyanovsk', 'Europe/Ulyanovsk'],
    label: 'Ulyanovsk Time',
  },
  {
    identifiers: ['Europe/Uzhgorod', 'Europe/Uzhgorod'],
    label: 'Eastern European Time - Uzhhorod',
  },
  {
    identifiers: ['Europe/Vienna', 'Europe/Vienna'],
    label: 'Central European Time - Vienna',
  },
  {
    identifiers: ['Europe/Vilnius', 'Europe/Vilnius'],
    label: 'Eastern European Time - Vilnius',
  },
  {
    identifiers: ['Europe/Volgograd', 'Europe/Volgograd'],
    label: 'Volgograd Standard Time',
  },
  {
    identifiers: ['Europe/Zaporozhye', 'Europe/Zaporozhye'],
    label: 'Eastern European Time - Zaporozhye',
  },
  {
    identifiers: ['Indian/Chagos', 'Indian/Chagos'],
    label: 'Indian Ocean Time',
  },
  {
    identifiers: ['Indian/Christmas', 'Indian/Christmas'],
    label: 'Christmas Island Time',
  },
  {
    identifiers: ['Indian/Cocos', 'Indian/Cocos'],
    label: 'Cocos Islands Time',
  },
  {
    identifiers: ['Indian/Kerguelen', 'Indian/Kerguelen'],
    label: 'French Southern & Antarctic Time',
  },
  {
    identifiers: ['Indian/Mahe', 'Indian/Mahe'],
    label: 'Seychelles Time',
  },
  {
    identifiers: ['Indian/Maldives', 'Indian/Maldives'],
    label: 'Maldives Time',
  },
  {
    identifiers: ['Indian/Mauritius', 'Indian/Mauritius'],
    label: 'Mauritius Standard Time',
  },
  {
    identifiers: ['Indian/Reunion', 'Indian/Reunion'],
    label: 'Réunion Time',
  },
  {
    identifiers: ['Pacific/Bougainville', 'Pacific/Bougainville'],
    label: 'Bougainville Time',
  },
  {
    identifiers: ['Pacific/Efate', 'Pacific/Efate'],
    label: 'Vanuatu Standard Time',
  },
  {
    identifiers: ['Pacific/Enderbury', 'Pacific/Enderbury'],
    label: 'Phoenix Islands Time',
  },
  {
    identifiers: ['Pacific/Fakaofo', 'Pacific/Fakaofo'],
    label: 'Tokelau Time',
  },
  {
    identifiers: ['Pacific/Fiji', 'Pacific/Fiji'],
    label: 'Fiji Time',
  },
  {
    identifiers: ['Pacific/Funafuti', 'Pacific/Funafuti'],
    label: 'Tuvalu Time',
  },
  {
    identifiers: ['Pacific/Galapagos', 'Pacific/Galapagos'],
    label: 'Galapagos Time',
  },
  {
    identifiers: ['Pacific/Gambier', 'Pacific/Gambier'],
    label: 'Gambier Time',
  },
  {
    identifiers: ['Pacific/Kiritimati', 'Pacific/Kiritimati'],
    label: 'Line Islands Time',
  },
  {
    identifiers: ['Pacific/Kosrae', 'Pacific/Kosrae'],
    label: 'Kosrae Time',
  },
  {
    identifiers: ['Pacific/Majuro', 'Pacific/Majuro'],
    label: 'Marshall Islands Time - Majuro',
  },
  {
    identifiers: ['Pacific/Marquesas', 'Pacific/Marquesas'],
    label: 'Marquesas Time',
  },
  {
    identifiers: ['Pacific/Nauru', 'Pacific/Nauru'],
    label: 'Nauru Time',
  },
  {
    identifiers: ['Pacific/Norfolk', 'Pacific/Norfolk'],
    label: 'Norfolk Island Time',
  },
  {
    identifiers: ['Pacific/Noumea', 'Pacific/Noumea'],
    label: 'New Caledonia Standard Time',
  },
  {
    identifiers: ['Pacific/Palau', 'Pacific/Palau'],
    label: 'Palau Time',
  },
  {
    identifiers: ['Pacific/Pitcairn', 'Pacific/Pitcairn'],
    label: 'Pitcairn Time',
  },
  {
    identifiers: ['Pacific/Port_Moresby', 'Pacific/Port_Moresby'],
    label: 'Papua New Guinea Time',
  },
  {
    identifiers: ['Pacific/Rarotonga', 'Pacific/Rarotonga'],
    label: 'Cook Islands Standard Time',
  },
  {
    identifiers: ['Pacific/Tahiti', 'Pacific/Tahiti'],
    label: 'Tahiti Time',
  },
  {
    identifiers: ['Pacific/Tarawa', 'Pacific/Tarawa'],
    label: 'Gilbert Islands Time',
  },
  {
    identifiers: ['Pacific/Tongatapu', 'Pacific/Tongatapu'],
    label: 'Tonga Standard Time',
  },
  {
    identifiers: ['Pacific/Wake', 'Pacific/Wake'],
    label: 'Wake Island Time',
  },
  {
    identifiers: ['Pacific/Wallis', 'Pacific/Wallis'],
    label: 'Wallis & Futuna Time',
  },
  {
    identifiers: ['UTC', 'UTC'],
    label: 'Coordinated Universal Time',
  },
  {
    identifiers: ['Pacific/Niue', 'Pacific/Niue'],
    label: 'Niue Time',
  },
];
